export default {
  DEV_AUTH_REQUEST: 'DEV_AUTH_REQUEST',
  DEV_AUTH_SUCCESS: 'DEV_AUTH_SUCCESS',
  DEV_AUTH_FAILURE: 'DEV_AUTH_FAILURE',
};



// WEBPACK FOOTER //
// ./src/redux/constants/DevAuthConstants.js